import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#525252",
      "clip-path": "url(#clip0_2069_79)"
    }, [
      _createElementVNode("path", { d: "M1.154 5.2c.433 0 .662-.245.662-.67V2.6c0-.85.45-1.284 1.266-1.284H5.06c.433 0 .67-.237.67-.662S5.493 0 5.06 0H3.066Q.502 0 .5 2.526V4.53c0 .426.237.67.654.67m14.684 0c.433 0 .662-.245.662-.67V2.525Q16.498 0 13.934 0h-2.002c-.425 0-.662.229-.662.654s.237.662.662.662h1.978c.809 0 1.274.434 1.274 1.284v1.93c0 .425.237.67.654.67M3.066 16H5.06c.433 0 .67-.237.67-.654 0-.425-.237-.662-.67-.662H3.082c-.817 0-1.266-.434-1.266-1.284v-1.93c0-.433-.237-.67-.662-.67s-.654.237-.654.67v1.995C.5 15.159 1.358 16 3.066 16m8.866 0h2.002c1.708 0 2.566-.85 2.566-2.534V11.47c0-.434-.237-.67-.662-.67s-.654.236-.654.67v1.93c0 .85-.465 1.283-1.274 1.283h-1.978c-.425 0-.662.237-.662.662 0 .417.237.654.662.654M4.766 11.323h.588V4.677h-.588zm1.323 0h1.104V4.677H6.089zm1.594 0h.694V4.677h-.694zm1.316 0h1.07V4.677h-1.07zm1.511 0h.858V4.677h-.858zm1.169 0h.547V4.677h-.547z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2069_79" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.5 0h16v16H.5z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }